import { Divider, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IRoleMain, MasterPages } from "../../commonFunctions/CommonFunctions";
import { getPermissions } from "../../commonFunctions/PermissionManger";

import { Header } from "../../Components/Header/Header";
import { useDispatch } from "react-redux";
import WSDataGridForDashboard, {
  IColumns
} from "../../Components/DataGrid/WSDataGridForDashboard";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../StateManagement/actions";
import ConfirmationDashboardPopup from "../../Components/Confirmation/ConfirmationDashboard";
import { IRows } from "../../Components/Filter/WSFilterComponent";
import WSButton from "../../Components/Button/WSButton";
import WSHiddenField from "../../Components/HiddenField/WSHiddenField";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import WSTextField, {
  CurrencyType,
  TextType
} from "../../Components/TextBox/WSTextBox";
import WSDateField from "../../Components/DateField/WSDateField";
import WSAutoCompleteDashBoard from "../../Components/AutoComplete/WSAutoCompleteDashBoard";
import dayjs from "dayjs";
import httpDash from "../../commonFunctions/htttpClientNew";
import { useForm } from "react-hook-form";

export const BillList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { edit } = getPermissions(MasterPages.Users, IRoleMain.Masters);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [openEdit, setOpenEdit] = useState(false);
  const [billId, setBillId] = useState("");
  const dispatch = useDispatch();
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const { showMessage } = useSnackbar();
  const params = useParams();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
//   const id = params?.id;
  const [category, setCategory] = useState<string>("");
  const [startDate, setStartDate] = useState<string>();

  const source = {
    url: "Bill/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [{ field: "UpdatedDate", direction: "desc" }]
    // sort:[]
  };

  const Suppliersource = {
    url: "Supplier/search",
    page: 1,
    pageSize: 10000,
    filter: [],
    sort: []
  };

  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getPromotionById(id: any) {
      try {
        const response: any = await httpDash.get(`Bill/${id}`);
        if (response) {
          setValue("invoiceNo", response?.invoiceNo);
          setValue("supplierId", response?.supplierId);
          setValue(
            "invDate",
            dayjs(response?.invoiceDate).format("DD/MM/YYYY")
          );
          setValue("dueDate", dayjs(response?.dueDate).format("DD/MM/YYYY"));
          setValue("amount", response?.amount);
          setValue("isCheckIssued", response?.chequeIssued);
          setValue("isHold", response?.isHold);
          setValue("id", response?.id);
          setCategory(response?.category);
        }
      } catch (error) {
        console.log("failed to retrieve data", error);
      }
    }
    if (billId) {
      getPromotionById(billId);
    }
  }, [billId]);

  /**updatedDate
   * Edit function
   * @param action
   * @param row
   */
  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      // navigate(`/bill/${row?.id}`)
      setOpenEdit(true);
      setBillId(row?.id);
    }
    if (action === "Delete") {
      setSelectedId(row.id); // Set the ID of the row to be deleted
      setPopupOpen(true);
    }
  };

  const handleSupplierChange = async (evt: any) => {
    const supid = evt?.value;
    try {
      if (supid) {
        const response: any = await httpDash.get(`Supplier/${supid}`);
        if (response?.data) {
          setCategory(response?.data?.category);
          setValue("invDate", null);
          setValue("dueDate", null);
        }
      }
    } catch (e) {}
  };

  const startDateChanged = (event: any) => {
    const categoryValues: Record<string, number> = {
      A: 7,
      A1: 10,
      B: 15,
      B1: 21,
      C: 30,
      C1: 45,
      D: 60
    };

    const cat = categoryValues[category] ?? 30; // Default to 30 if not found
    let dueDate = dayjs(convertToDate(event)).add(cat, "day");

    // Keep adjusting the due date until it is not Sunday and not 3rd/4th/5th
    while (
      dueDate.day() === 0 || // 0 = Sunday
      [3, 4, 5].includes(dueDate.date())
    ) {
      dueDate = dueDate.add(1, "day");
    }

    setStartDate(dueDate.format("DD/MM/YYYY"));
  };

  const convertToDate = (dateString: string) => {
    // Parse the date string using the custom format
    const date = dayjs(dateString, "DD/MM/YYYY");

    if (date.isValid()) {
      return date; // Returns a dayjs object
    } else {
      console.error("Invalid date format");
      return null;
    }
  };

  const handleClick = () => {
    navigate("/bill/create");
  };
  const transFormData = (data: any) => {
    data &&
      data?.map((item: any) => {
        item.name = item?.supplier?.name;
      });
    return data;
  };
  const handleDelete = (response: any) => {
    dispatch(resetDataComponent("billList"));
    showMessage("Bill deleted successfully!", "success");
  };

  const handleData = async (data: any) => {
    try {
      const invDate = dayjs(data.invDate, "DD/MM/YYYY").format(
        "YYYY-MM-DDTHH:mm:ss.SSS"
      );
      const dueDate = dayjs(data.dueDate, "DD/MM/YYYY").format(
        "YYYY-MM-DDTHH:mm:ss.SSS"
      );
      let request = {
        supplierId: data?.supplierId,
        invoiceNo: data.invoiceNo,
        category: category,
        invDate: invDate,
        dueDate: dueDate,
        amount: data.amount,
        chequeIssued: data.isCheckIssued,
        isHold: data?.isHold
      };

      const response: any = await httpDash.put(`Bill/${billId}`, request);
      console.log('response bil',response)
      if (response) {
        showMessage(
          response?.message,
          response.success === true ? "success" : "error"
        );
        if (response?.success === true) {
          dispatch(resetDataComponent("billList"));
        }
      }
    } catch (e: any) {
      console.log('err is bill',e)
      showMessage(e.response?.data?.error);
    } finally {
      setOpenEdit(false);
      setBillId("");
      reset();
    }
  };

  const handleCancelClick = () => {
    setOpenEdit(false);
    setBillId("");
  };

  const filterRows: IRows[] = [
    // {
    //   label: "Name",
    //   fieldName: "Supplier.Name",
    //   type: "text",
    //   operator: "like"
    // },

    // {
    //   label: "Invoice Number",
    //   fieldName: "InvoiceNo",
    //   type: "text",
    //   operator: "like"
    // },

    // {
    //   label: "Category",
    //   fieldName: "Category",
    //   type: "text",
    //   operator: "like"
    // },

    // {
    //   label: "Amount",
    //   fieldName: "Amount",
    //   type: "double",
    //   operator: "like"
    // },


    {
      label: "Invoice Date",
      fieldName: "InvoiceDate",
      type: "betweenDate",
      operator: "between",
    },

    {
      label: "Is Hold",
      fieldName: "IsHold",
      type: "radio",
      align: "horizontal",
      options: [
        { label: "Yes", value: "true" },
        { label: "No", value: "false" }
      ],
      operator: "eq"
    }
  ];

  const columns: IColumns[] = [
    {
      header: "Supplier Name",
      fieldName: "name",
      type: "default"
    },
    {
      header: "Invoice No",
      fieldName: "invoiceNo",
      type: "default"
    },
    {
      header: "Amount",
      fieldName: "amount",
      type: "currency"
    },
    {
      header: "Invoice Date",
      fieldName: "invoiceDate",
      type: "date"
    },
    {
      header: "Due Date",
      fieldName: "dueDate",
      type: "date"
    },

    {
      header: "Category",
      fieldName: "category",
      type: "default"
    },
    {
      header: "Is Hold",
      fieldName: "isHold",
      type: "booleanToString",
      groupType: "boolean"
    },
    {
      header: "Is Cheque Issued",
      fieldName: "chequeIssued",
      type: "booleanToString",
      groupType: "boolean"
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];
  return (
    <>
      {" "}
      <Grid item container spacing={2}>
        {/* <Grid item sm={12} xs={12}>
                <WSImageView imgUrl={fullImage1} isAnimated={false} imageSx={{ height: 300 }} />
            </Grid> */}
        <Grid item sm={12} xs={12}>
          <Divider />
        </Grid>
      </Grid>
      <Header
        type="simple"
        isDivider={true}
        title="Bills"
        id={"billListHeader"}
        headerSx={{ marginTop: 0 }}
      />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGridForDashboard
            id="billList"
            title="Bills"
            columns={columns}
            searchBox={{ fieldName: "Category,InvoiceNo,Supplier.Name" }}
            source={source}
            filterFields={filterRows}
            // clientFilter={true}
            transFormData={transFormData}
            addButton={{ label: "New", color: "secondary" }}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke"
            }}
          />
          {selectedId !== null && (
            <ConfirmationDashboardPopup
              apiUrl={"Bill/"}
              id={selectedId}
              confirmMessage="Are you sure you want to delete this item?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleDelete}
            />
          )}
        </Grid>

        {openEdit && (
          <form onSubmit={handleSubmit(handleData)}>
            <Grid
              sx={{
                ml:2,
                padding: 4,
                backgroundColor: "#fff",
                borderRadius: 2,
                border: "1px solid lightgrey",
                marginTop: 3
              }}
            >
              <Grid item container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <WSAutoCompleteDashBoard
                    label={"Supplier"}
                    {...register("supplierId")}
                    onChange={handleSupplierChange}
                    id="supplierId"
                    name="supplierId"
                    control={control}
                    transFormData={transFormData}
                    source={Suppliersource}
                    rules={{ required: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSTextField
                    label={"Invoice No"}
                    {...register("invoiceNo")}
                    id="invoiceNo"
                    name="invoiceNo"
                    control={control}
                    rules={{ required: true }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <WSDateField
                    id="invDate"
                    name="invDate"
                    label={"Invoice Date"}
                    dateFormat="DD/MM/YYYY"
                    onChange={startDateChanged}
                    control={control}
                    setValue={setValue}
                    rules={{ required: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSDateField
                    id="dueDate"
                    name="dueDate"
                    label={"Due Date"}
                    dateFormat="DD/MM/YYYY"
                    control={control}
                    defaultValue={startDate}
                    // disabled={true}
                    setValue={setValue}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSTextField
                    label={"Amount"}
                    {...register("amount")}
                    id="amount"
                    name="amount"
                    type={TextType.Currency}
                    currency={CurrencyType.Rupee}
                    control={control}
                    rules={{ required: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <WSSCheckBoxField
                    control={control}
                    id={`isCheckIssued`}
                    defaultValue={false}
                    name={`isCheckIssued`}
                    rules={{ required: false }}
                    label="Is Check Issued"
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <WSSCheckBoxField
                    control={control}
                    id={`isHold`}
                    defaultValue={false}
                    name={`isHold`}
                    rules={{ required: false }}
                    label="Is Hold"
                  />
                </Grid>

                <Grid item xs={12} sm={6} style={{ display: "none" }}>
                  <WSHiddenField name="id" control={control} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    marginTop: "3rem",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 2
                  }}
                >
                  <WSButton
                    id="submit"
                    label={"Save"}
                    type="submit"
                    size="medium"
                  />
                  <WSButton
                    id="cancel"
                    label={"Cancel"}
                    type="button"
                    onClick={handleCancelClick}
                    size="medium"
                    className="ws-cancel"
                  />
                </Grid>
              </Grid>
            </Grid>
          </form>
        )}
      </Grid>
    </>
  );
});
